import ordersApi from "./ordersApi";
import type {
  DealerDriverInsightItemDto,
  DealerDriverInsightResponseDto,
  DriverInsightSnapshot,
} from "types/dealerDriverInsight";

export interface GetDealerDriversInsightParams {
  dealerId: string;
  driverIds: string[];
}

function buildInsightQuery(dealerId: string, driverIds: string[]): string {
  const params = new URLSearchParams();
  params.append("dealerId", dealerId);
  driverIds.forEach((driverId) => params.append("driverIds", driverId));
  return `?${params.toString()}`;
}

export async function getDealerDriversInsight({
  dealerId,
  driverIds,
}: GetDealerDriversInsightParams): Promise<DealerDriverInsightItemDto[]> {
  if (!dealerId || driverIds.length === 0) {
    return [];
  }

  const { data } = await ordersApi.get<DealerDriverInsightResponseDto>(
    `v1/dealers/${dealerId}/drivers/insight${buildInsightQuery(
      dealerId,
      driverIds,
    )}`,
  );

  return data?.data ?? [];
}

export function mapDriverInsightsById(
  items: DealerDriverInsightItemDto[],
): Map<string, DriverInsightSnapshot> {
  const insightsByDriverId = new Map<string, DriverInsightSnapshot>();

  items.forEach((item) => {
    if (!item.id) return;
    insightsByDriverId.set(item.id, {
      totalActiveOrders: item.totalActiveOrders ?? 0,
      totalDeliveredOrders: item.totalDeliveredOrders ?? 0,
    });
  });

  return insightsByDriverId;
}
